<div class="cr-back-button" [ngClass]="cssClasses">
  <button
    type="button"
    class="back-button"
    [routerLink]="goBack ? null : routerLink"
    (click)="onClick()"
    [matTooltip]="tooltipText"
    [matTooltipDisabled]="!tooltipText"
    matTooltipClass="universalTooltip"
    matTooltipPosition="below"
    matTooltipShowDelay="450">
    <mat-icon class="back-icon" aria-hidden="true">{{ icon }}</mat-icon>
    <span class="label">
      <ng-content></ng-content>
    </span>
  </button>
</div>
